export function money(v, ccy = "USD") {
  if (v == null || isNaN(v)) return "—";
  try {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: ccy || "USD",
      minimumFractionDigits: 2,
    }).format(v);
  } catch {
    return `$${Number(v).toLocaleString()}`;
  }
}

export function num(v, digits = 0) {
  if (v == null || isNaN(v)) return "—";
  return Number(v).toLocaleString("en-US", {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });
}

export function pct(observed, prior) {
  if (prior == null || observed == null || prior === 0) return null;
  return ((observed - prior) / Math.abs(prior)) * 100;
}

export function fmtDate(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (isNaN(d)) return iso;
  return d.toLocaleDateString("en-US", { year: "numeric", month: "short", day: "2-digit" });
}

export const SEVERITY = {
  5: { label: "Critical", cls: "bg-neg text-white border-neg", rail: "border-l-neg", dot: "bg-neg" },
  4: { label: "High", cls: "bg-neg/10 text-neg border-neg/40 dark:bg-neg/15", rail: "border-l-neg", dot: "bg-neg" },
  3: { label: "Medium", cls: "bg-amber-100 text-amber-900 border-amber-300 dark:bg-amber-500/15 dark:text-amber-300 dark:border-amber-500/40", rail: "border-l-amber-400", dot: "bg-amber-400" },
  2: { label: "Low", cls: "bg-sky-100 text-sky-900 border-sky-300 dark:bg-sky-500/15 dark:text-sky-300 dark:border-sky-500/40", rail: "border-l-sky-400", dot: "bg-sky-400" },
  1: { label: "Info", cls: "bg-muted text-muted-foreground border-border", rail: "border-l-border", dot: "bg-muted-foreground" },
};

export function sevRail(sev) {
  return (SEVERITY[sev] && SEVERITY[sev].rail) || "border-l-transparent";
}

export function sevDot(sev) {
  return (SEVERITY[sev] && SEVERITY[sev].dot) || "bg-muted-foreground";
}

export const REVIEW = {
  NEW: "bg-sky-100 text-sky-900 border-sky-300 dark:bg-sky-500/15 dark:text-sky-300 dark:border-sky-500/40",
  ACKNOWLEDGED: "bg-amber-100 text-amber-900 border-amber-300 dark:bg-amber-500/15 dark:text-amber-300 dark:border-amber-500/40",
  EXPLAINED: "bg-violet-100 text-violet-900 border-violet-300 dark:bg-violet-500/15 dark:text-violet-300 dark:border-violet-500/40",
  CORRECTED: "bg-emerald-100 text-emerald-900 border-emerald-300 dark:bg-emerald-500/15 dark:text-emerald-300 dark:border-emerald-500/40",
  DISMISSED: "bg-muted text-muted-foreground border-border",
};

export const STATUS = {
  PASS: "text-pos",
  FAIL: "text-neg",
  INSUFFICIENT_DATA: "text-muted-foreground",
  NOT_APPLICABLE: "text-muted-foreground",
};

export function moneyParts(v, ccy = "USD") {
  const s = money(v, ccy);
  if (s === "—") return { main: "—", cents: "" };
  const i = s.lastIndexOf(".");
  if (i === -1) return { main: s, cents: "" };
  return { main: s.slice(0, i), cents: s.slice(i) };
}
